export default "__VITE_ASSET__ChPpIcW___"